import * as M from '@mui/material';
import { styled } from '@mui/material/styles';
import colors from '../../themes/colors';
import fonts from '../../themes/fonts';

export const OptionLabelText = M.styled(M.Typography)(() => ({
  font: fonts.Medium,
  color: colors.blackSecondary,
}));

export const SearchOptionContainer = M.styled(M.Box)(() => ({
  display: 'flex',
  height: '41px',
  alignItems: 'center',
  cursor: 'pointer',
  backgroundColor: colors.white,
  borderRadius: '3px',
  border: `1px solid ${colors.grayMain}`,
  padding: '0 15px',
  boxSizing: 'border-box',
}));

export const SearchText = M.styled(M.Typography)(() => ({
  fontSize: '18px',
  color: colors.white,
  fontFamily: fonts.Bold,
}));

export const SearchFormSelect = styled(M.FormControl)({
  border: 'none',
});

export const BootstrapInput = styled(M.InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: '24px',
  },
  '& .MuiInputBase-input': {
    borderRadius: '4px',
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    fontSize: '16px',
    padding: '8px 26px 8px 12px',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: '4px',
      borderColor: '#80bdff',
    },
  },
}));

export const SearchSelect = styled(M.Select)({
  backgroundColor: colors.transparent,
  border: 'none',
  '&:active': {
    outline: 'none',
    boxShadow: 'none',
    backgroundColor: colors.transparent,
  },
  '&:focus': {
    outline: 'none',
    boxShadow: 'none',
    backgroundColor: colors.transparent,
  },
});

export const SearchInput = styled(M.InputBase)({
  border: 'none',
  fontSize: '20px',
  '&::placeholder': {
    fontSize: '20px',
  },
  '& .MuiInputBase-input': {
    fontSize: '20px',
    '&::placeholder': {
      fontSize: '14px',
      color: colors.graySecond,
      fontFamily: fonts.Medium,
    },
  },
});

const styles = {
  root: {
    width: '100%',
    paddingTop: '20px',
    backgroundColor: '#f0f0f0',
  },
  inline: {
    display: 'inline',
  },
  searchInput: {
    borderRadius: '4px',
    border: 'solid 1px #bebfc0',
    width: '100%',
  },
  searchField: {
    width: '100%',
    backgroundColor: '#ffffff',
    border: '1px solid #bebfc0',
    height: '50px',
    borderRadius: '4px',
    paddingLeft: '5px',
    '&::before': {
      borderBottom: 'none',
    },
  },
  searchBtn: {
    float: 'right',
    width: '100%',
    height: '50px',
    backgroundColor: '#887fff',
  },
  searchText: {
    border: '1px solid #bebfc0',
  },
  addDriverBtn: {
    backgroundColor: '#75c31e',
    color: '#ffffff',
    fontWeight: 'bold',
  },
  driverList: {
    paddingTop: '10px',
  },
  driverItem: {
    border: 'solid 1px #bebfc0',
    textAlign: 'center',
    color: 'text.secondary',
    '&:hover': {
      borderColor: colors.black35,
    },
  },
  itemDriverName: {
    fontSize: '14px',
    fontWeight: 500,
    paddingLeft: '10px',
    fontFamily: 'AvenirNext-Bold',
  },
  itemColumn: {
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
    display: 'flex',
    alignItems: 'center',
  },
  columnStatus: {
    justifyContent: 'flex-end',
    fontSize: '12px',
  },
  columnPhone: {
    justifyContent: 'flex-end',
    fontSize: '12px',
  },
  driverItemWrapper: {
    padding: '0px',
    cursor: 'pointer',
    backgroundColor: '#f0f0f0',
  },
  avatar: {
    width: '60px',
    height: '60px',
  },
  driverStatus: {
    fontFamily: 'AvenirNext-Bold',
    fontWeight: 400,
    fontSize: '11px',
  },
};

export default styles;
